module.exports = __webpack_public_path__ + "img/fig7.3.2bf014bb.png";